module.exports = __webpack_public_path__ + "static/img/fullscaleT4.24cf0d8a.png";